import React, { useEffect, useState } from 'react';
import './App.css';
import './styles/animations.css';
import Header from './components/Header';
import EnterpriseFeatures from './components/EnterpriseFeatures';
import AnaValue from './components/AnaValue';
import AgenticPersonas from './components/AgenticPersonas';
import Comparison from './components/Comparison';
import Footer from './components/Footer';
import styles from './components/Header/Header.module.css';
const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Ensure dark background is applied before showing content
    document.documentElement.style.backgroundColor = '#0A0A0A';
    document.body.style.backgroundColor = '#0A0A0A';
    
    // Add a small delay to ensure smooth transition
    const timer = setTimeout(() => {
      setIsLoading(false);
      
      // Initialize intersection observer after loading
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              requestAnimationFrame(() => {
                entry.target.classList.add('active');
              });
            }
          });
        },
        {
          root: null,
          rootMargin: '-10%',
          threshold: 0.1
        }
      );

      // Observe all reveal elements with a slight delay
      setTimeout(() => {
        document.querySelectorAll('.reveal').forEach((element) => {
          observer.observe(element);
        });
      }, 100);
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (isLoading) {
    return <div style={{ 
      backgroundColor: '#0A0A0A',
      minHeight: '100vh',
      width: '100%'
    }} />;
  }

  return (
    <div className="App">
      <Header />
      <main>
            <div className={styles.loveHeader}>
        <p className="text-sm text-gray-400">
          Built with <span style={{ color: '#FF0000' }}>♥</span> by <span className="text-[#FF3D00]">Ana</span>
        </p>
      </div>
        <section className="hero">
          <div className="hero-background animate-fadeIn">
            <div className="gradient-orb orb-1 animate-floating"></div>
            <div className="gradient-orb orb-2 animate-floating delay-200"></div>
            <div className="gradient-orb orb-3 animate-floating delay-400"></div>
          </div>
          
          <div className="container">
            <h1>
              <span className="hero-line">Build Better.</span>
              <span className="hero-line">Build Faster.</span>
              <span className="hero-line">Build Secure.</span>
            </h1>
            <p className="hero-subtitle">
              We're revolutionizing development with powerful AI-driven tools and intelligent solutions.
            </p>
            <a 
              href="https://calendly.com/openana" 
              className="cta-button"
              target="_blank"
              rel="noopener noreferrer">
              Onboard Ana
            </a>
          </div>
        </section>
        
        <section className="reveal">
          <div className="container">
            <AnaValue />
          </div>
        </section>

        <section className="reveal">
          <div className="container">
            <AgenticPersonas />
          </div>
        </section>

        <section className="reveal">
          <div className="container">
            <EnterpriseFeatures />
          </div>
        </section>

        <section className="reveal">
          <div className="container">
            <Comparison />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default App;
